
import { SubscriptionPlan } from "@/lib/types";
import { TableCell, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { PlanFeaturesBadges } from "./PlanFeaturesBadges";
import { PlanActionsMenu } from "./PlanActionsMenu";

interface SubscriptionPlanRowProps {
  plan: SubscriptionPlan;
  onEdit: (plan: SubscriptionPlan) => void;
  onDelete: (plan: SubscriptionPlan) => void;
  formatPrice: (price: number | null) => string;
}

export function SubscriptionPlanRow({ plan, onEdit, onDelete, formatPrice }: SubscriptionPlanRowProps) {
  return (
    <TableRow>
      <TableCell className="font-medium">{plan.name}</TableCell>
      <TableCell className="capitalize">{plan.plan_type}</TableCell>
      <TableCell>{formatPrice(plan.monthly_price)}</TableCell>
      <TableCell>{formatPrice(plan.annual_price)}</TableCell>
      <TableCell>
        {plan.is_active ? (
          <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
            Active
          </Badge>
        ) : (
          <Badge variant="outline" className="bg-gray-50 text-gray-700 border-gray-200">
            Inactive
          </Badge>
        )}
      </TableCell>
      <TableCell>
        <PlanFeaturesBadges features={plan.features} />
      </TableCell>
      <TableCell className="text-right">
        <PlanActionsMenu plan={plan} onEdit={onEdit} onDelete={onDelete} />
      </TableCell>
    </TableRow>
  );
}
